import React, {useState, useEffect} from "react";

function InterestFormItem( { interest, interestsSelected } ) {
    const [ checked, setChecked ] = useState(interest.checked);

    const handleInterstClick = async (event, interest) => {
      await setChecked(event.target.checked);
      interest.checked = event.target.checked;
      interestsSelected(interest);
    }

    return(
        <>
          <label>
            <input onChange={(event) => handleInterstClick(event, interest)} className="facet__input" type="checkbox" checked={checked} name={interest.name} id={interest.id} label={interest.label} />
            <span className="check"></span>
            <span className="label">{interest.label}</span>
          </label>
        </>
    )
}
export default InterestFormItem;
